<div class="editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <app-text-format-config
        [device]="device"
        [objectChoosing]="objectChoosing"
        [class]="class"
        [config]="config"
        
        [staticdata]="staticdata"
        [textContentClass]="class['date-create-product__content']"
        [textWrapperClass]="class['date-create-product__wrapper']"
      >
      </app-text-format-config>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" >
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing"
                    [isBlock]="false">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->
      
      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <div class="editor-field-body">
            <div class="config-text" style="width: 100%" >
              <mat-form-field style="width: 100%">
                <mat-label>{{'nhan_ngay' | translate}}</mat-label>
                <textarea matInput 
                  [ngModel]="(staticdata?.['label_' + functionService.selectedLanguageCode] ?? '') | vhLanguage : '' : objectChoosing.component" 
                  (ngModelChange)="staticdata['label_' + functionService.selectedLanguageCode] = $event" 
                  (blur)="updateContent('label')"></textarea>
              </mat-form-field>
            </div>
            <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    
                    [staticdata]="staticdata"
                    [textContentClass]="class['date-create-product__content']"
                    [textWrapperClass]="class['date-create-product__wrapper']"
                    >
            </app-text-format-config>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div>
                  <div class="config-name">
                    <p>{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['date-create-product__content']['letter-spacing'] | vhnumber"
                      (nzBlur)="updateClass()"
                      (ngModelChange)="class['date-create-product__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['date-create-product__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['date-create-product__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div>
                  <div class="config-name">
                     <p>{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number
                      [(ngModel)]="this.class['date-create-product__content']['line-height']" (nzBlur)="updateClass()"
                      [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['date-create-product__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- ĐỊNH DẠNG THỜI GIAN -->
      <li nz-submenu nzTitle="{{'dinh_dang_thoi_gian' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-time-format-config [objectChoosing]="objectChoosing" [device]="device" [config]="config">
        </app-time-format-config>
      </li>

      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-text-style-config
                [config]="config"
                [class]="class"
                [staticdata]="staticdata"
                [device]="device"
                [objectChoosing]="objectChoosing"
                [textContentClass]="class['date-create-product__content']"
                [textWrapperClass]="class['date-create-product__wrapper']"
                [filterConfig]="config['filter']"
                [isShape]="false"
        >
        </app-text-style-config>
      </li>
      <!-- BIỂU TƯỢNG -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-symbol-config
          [device]="device"
          [class]="class"
          [config]="config"
          [symbolClass]="class['date-create-product__wrapper']"
          [fontSizeIconClass]="class['date-create-product__icon-inner']"
          [symbolConfig]="config['flex-direction']"
          [objectChoosing]="objectChoosing"
        >
        </app-symbol-config>
      </li>
      
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 1">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>